import React from 'react';
import { ReactComponent as ReadedCheck } from 'assets/icons/readed-check.svg';
import { ReactComponent as ReadedUncheck } from 'assets/icons/readed-uncheck.svg';

type ReadedIconProps = {
	checked: boolean;
	size?: number;
};

export const ReadedIcon = ({ checked, size = 18 }: ReadedIconProps) => {
	return checked ? <ReadedCheck width={size} height={size} /> : <ReadedUncheck width={size} height={size} />;
};
